import { createSlice } from "@reduxjs/toolkit";
import { act } from "react";

const initialState = {
  isLoadingVendors: false,
  isLoadingVendorCustomerList: false,
  isLoadingVendorsProducts: false,
  isLoadingVendor: false,
  isSavingEditVendor: false,
  vendors: [],
  vendorsProducts: [],
  vendorsProductsPage: 1,
  vendorsProductsTotalPages: 0,
  customerList: [],
  vendor: {},
  count: 0,
  page: 1,
  totalPages: 0,
  countCustomer: 0,
  pageCustomer: 0,
  totalPagesCustomer: 0,
  currentReport: [],
  currentReportIsLoading: false,
  productComparison: [],
  productComparisonIsLoading: false,
  productComparisonPage: 1,
  productComparisonTotalPages: 0,
  productBehavior: [],
  productBehaviorIsLoading: false,
};

export const vendorSlice = createSlice({
  name: "vendors",
  initialState,
  reducers: {
    loadVendors: (state) => {
      state.isLoadingVendors = true;
      state.vendors = [];
    },
    loadedVendors: (state, action) => {
      state.vendors = action.payload.result;
      state.count = action.payload.count;
      state.page = action.payload.page;
      state.totalPages = action.payload.totalPages;
      state.isLoadingVendors = false;
    },
    search: (state, { payload }) => {
      state.isLoadingCustomer = true;
      state.page = 1;
      state.vendors = payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    loadCurrentReport: (state, { payload }) => {
      state.currentReport = payload;
    },
    setLoadingCurrentReport: (state, { payload }) => {
      state.currentReportIsLoading = payload;
    },
    loadProductBehavior: (state, { payload }) => {
        state.productBehavior = payload;
      },
      setLoadingProductBehavior: (state, { payload }) => {
        state.productBehaviorIsLoading = payload;
      },
    loadProductComparison: (state, { payload }) => {
      state.productComparison = payload.result;
      state.productComparisonTotalPages = payload.totalPages;
    },
    setLoadingProductComparison: (state, { payload }) => {
      state.productComparisonIsLoading = payload;
    },
    setProductComparisonPage: (state, { payload }) => {
      state.productComparisonPage = payload;
    },
    clearProductComparison: (state, { payload }) => {
      state.productComparison = [];
    },
    loadVendorProductsById: (state) => {
      state.isLoadingVendorsProducts = true;
      state.vendorsProducts = [];
    },
    loadedVendorProductsById: (state, action) => {
      state.isLoadingVendorsProducts = false;
      state.vendorsProducts = action.payload.result;
      state.vendorsProductsPage = action.payload.page;
      state.vendorsProductsTotalPages = action.payload.totalPages;
    },
    setVendorProductPage: (state, { payload }) => {
      state.vendorsProductsPage = payload;
    },
    loadVendorById: (state) => {
      state.isLoadingVendor = false;
      state.vendor = {};
    },
    loadedVendorById: (state, action) => {
      state.isLoadingVendor = false;
      state.vendor = action.payload;
    },
    loadVendorsCustomerList: (state) => {
      state.isLoadingVendorCustomerList = true;
      state.customerList = [];
    },
    loadedVendorsCustomerList: (state, action) => {
      state.isLoadingVendorCustomerList = false;
      state.customerList = action.payload.result;
      state.countCustomer = action.payload.count;
      state.pageCustomer = action.payload.page;
      state.totalPagesCustomer = action.payload.totalPages;
    },
    editVendor: (state) => {
      state.isSavingEditVendor = true;
    },
    editedVendor: (state) => {
      state.isSavingEditVendor = false;
    },
    updateVendorInList: (state, action) => {
      const updatedVendor = action.payload;
      const index = state.vendors.findIndex(
        (vendor) => vendor.vendor_id == updatedVendor.id
      );
      if (index !== -1) {
        state.vendors[index].name = updatedVendor.name;
        state.vendors[index].image_url = updatedVendor.imgUrl;
      }
    },
  },
});
export const vendorActions = vendorSlice.actions;

export default vendorSlice.reducer;
